import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Button,
} from '@mui/material';

interface TemplateChangeConfirmDialogProps {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export const TemplateChangeConfirmDialog: React.FC<TemplateChangeConfirmDialogProps> = ({
  open,
  onConfirm,
  onCancel,
}) => {
  return (
    <Dialog open={open} onClose={onCancel} maxWidth="xs">
      <DialogTitle>Change Template?</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Changing the template will clear your current task checklist including
          manually attached lists and unsaved edits. This cannot be undone.
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>Cancel</Button>
        <Button onClick={onConfirm} variant="contained" color="warning">
          Continue
        </Button>
      </DialogActions>
    </Dialog>
  );
};
